var _rect, _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _g3, _g4, _path9, _path10, _path11, _g5, _path12, _g6, _path13, _g7, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMascotte9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#F4EFFE"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M480.606 63.1739C544.511 59.902 564.912 104.122 665.725 85.7497C746.112 71.1018 780.719 125.792 790.73 159.769C795.507 176.002 796.721 239.451 752.609 240.357C602.906 243.478 482.957 407.926 410.785 264.116C381.512 205.776 335.529 70.6236 480.606 63.1739Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M-141.394 -87.8261C-77.4885 -91.098 -57.0883 -46.8776 43.7247 -65.2503C124.112 -79.8982 158.719 -25.2079 168.73 8.76903C173.507 25.0025 174.721 88.4512 130.609 89.3573C-19.0939 92.4781 -139.043 256.926 -211.215 113.116C-240.488 54.7763 -286.471 -80.3764 -141.394 -87.8261Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 37,
    width: 370,
    height: 140,
    rx: 30,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.42 332.309C242.239 359.374 266.336 389.656 296.302 389.859C326.28 390.063 350.783 360.119 350.964 333.042C351.144 305.977 326.946 292.027 296.968 291.824C266.991 291.62 242.601 305.232 242.409 332.297L242.42 332.309Z",
    fill: "url(#paint0_linear_0_1)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352.505 329.81L351.872 327.002C350.488 320.861 344.387 317.004 338.246 318.388L278.635 331.822C272.493 333.206 268.636 339.307 270.02 345.449L270.653 348.256C272.037 354.398 278.138 358.255 284.28 356.871L343.891 343.437C350.032 342.053 353.889 335.952 352.505 329.81Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M318.835 348.254L319.467 345.446C320.852 339.304 316.995 333.203 310.853 331.819L251.242 318.385C245.1 317.001 238.999 320.858 237.615 327L236.983 329.807C235.598 335.949 239.455 342.05 245.597 343.434L305.208 356.868C311.35 358.252 317.451 354.395 318.835 348.254Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M261.901 227.083L243.808 216.067C238.278 212.692 231.325 212.67 225.772 216.011C216.393 221.631 209.339 230.424 205.885 240.785C200.151 257.975 207.826 276.767 223.944 285.029L241.867 294.216L261.889 227.072L261.901 227.083Z",
    fill: "#9E83FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.515 237.275L243.47 228.121C238.865 225.322 233.086 225.3 228.47 228.076C220.682 232.749 214.813 240.063 211.946 248.674C207.183 262.963 213.56 278.584 226.969 285.458L241.867 293.099L258.515 237.275Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M324.768 227.083L342.86 216.067C348.391 212.692 355.343 212.67 360.896 216.011C370.264 221.631 377.318 230.424 380.772 240.785C386.506 257.975 378.831 276.767 362.713 285.029L344.79 294.216L324.768 227.072V227.083Z",
    fill: "#9E83FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M328.153 237.275L343.198 228.121C347.803 225.322 353.582 225.3 358.198 228.076C365.986 232.749 371.855 240.063 374.722 248.674C379.485 262.963 373.108 278.584 359.7 285.458L344.801 293.099L328.153 237.275Z",
    fill: "url(#paint4_linear_0_1)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.718 280.424C353.718 313.776 326.686 328.731 293.334 328.731C259.982 328.731 232.951 313.776 232.951 280.424C232.951 247.072 270.174 211.26 293.334 211.26C316.495 211.26 353.718 247.072 353.718 280.424Z",
    fill: "url(#paint5_linear_0_1)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.479 215.571C285.806 219.657 285.896 231.553 285.896 231.553C286.02 231.959 286.596 231.824 286.788 231.699C287.612 231.169 289.508 228.855 289.508 228.855C289.745 228.517 290.253 228.596 290.388 228.979C290.388 228.979 291.641 233.291 291.923 237.162C291.946 237.41 292.691 237.275 292.883 237.14C294.677 235.842 296.19 228.72 296.19 228.72C296.302 228.325 296.799 228.223 297.059 228.528C297.059 228.528 299.09 229.453 300.151 232.23C300.23 232.444 300.862 232.162 301.032 232.004C304.406 228.912 306.46 217.196 303.932 213.55C300.343 208.37 275.535 211.767 280.479 215.56V215.571Z",
    fill: "#8058EA"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M286.765 267.839C286.765 280.311 278.933 290.412 269.271 290.412C259.61 290.412 251.777 280.311 251.777 267.839H286.765Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M335.298 267.839C335.298 280.311 327.465 290.412 317.803 290.412C308.142 290.412 300.309 280.311 300.309 267.839H335.298Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 251,
    y: 267,
    width: 36,
    height: 24
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M286.765 267.839C286.765 280.311 278.933 290.412 269.271 290.412C259.61 290.412 251.777 280.311 251.777 267.839H286.765Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.687 266.078C281.687 261.715 278.149 258.178 273.786 258.178C269.422 258.178 265.885 261.715 265.885 266.078V273.979C265.885 278.342 269.422 281.88 273.786 281.88C278.149 281.88 281.687 278.342 281.687 273.979V266.078Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.093 272.851C274.275 272.851 276.043 271.082 276.043 268.901C276.043 266.719 274.275 264.95 272.093 264.95C269.911 264.95 268.143 266.719 268.143 268.901C268.143 271.082 269.911 272.851 272.093 272.851Z",
    fill: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 300,
    y: 267,
    width: 36,
    height: 24
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M335.298 267.839C335.298 280.311 327.465 290.412 317.803 290.412C308.142 290.412 300.309 280.311 300.309 267.839H335.298Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.19 266.078C321.19 261.715 317.652 258.178 313.289 258.178C308.925 258.178 305.388 261.715 305.388 266.078V273.979C305.388 278.342 308.925 281.88 313.289 281.88C317.652 281.88 321.19 278.342 321.19 273.979V266.078Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.596 272.851C313.778 272.851 315.546 271.082 315.546 268.901C315.546 266.719 313.778 264.95 311.596 264.95C309.414 264.95 307.646 266.719 307.646 268.901C307.646 271.082 309.414 272.851 311.596 272.851Z",
    fill: "#FEFFFF"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M270.23 311.36C270.23 311.36 266.416 296.101 253.267 299.566",
    stroke: "#806CFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.42 361.564C303.955 361.383 306.438 362.388 307.488 362.072C309.282 361.541 307.679 358.855 307.6 358.392C306.46 351.722 307.521 337.794 308.797 331.858C310.704 322.964 313.932 310.402 313.661 304.408C313.199 293.889 305.749 287.851 297.059 287.095C288.368 286.327 279.79 292.727 277.691 301.259C275.591 309.758 282.905 327.32 287.014 335.007C291.415 343.246 296.043 356.609 295.558 361.598C295.512 362.106 295.941 363.821 297.894 363.686C299.429 363.573 300.354 361.812 302.42 361.575V361.564Z",
    fill: "url(#paint6_linear_0_1)"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M261 202L234 177H256.909L261 202Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 78,
    y: 22,
    width: 430,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623529 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 234.409,
    y: 286.821,
    width: 124.556,
    height: 114.039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 224.951,
    y: 206.26,
    width: 136.767,
    height: 133.472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 277.83,
    y: 209.908,
    width: 29.23,
    height: 30.3926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_0_1",
    x: 269.32,
    y: 282.032,
    width: 52.3574,
    height: 92.6611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 296.704,
    y1: 291.822,
    x2: 296.703,
    y2: 389.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 255.484,
    y1: 472.272,
    x2: 237.588,
    y2: 516.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 332.533,
    y1: 468.685,
    x2: 350.429,
    y2: 513.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 258.503,
    y1: 259.543,
    x2: 210.377,
    y2: 259.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 328.153,
    y1: 259.543,
    x2: 376.291,
    y2: 259.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 293.334,
    y1: 328.731,
    x2: 293.334,
    y2: 211.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 292.446,
    y1: 287.329,
    x2: 305.275,
    y2: 362.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.668,
    height: 210.53,
    fill: "white",
    transform: "translate(204 201)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotte9);
export default __webpack_public_path__ + "static/media/mascotte9.b5c0acd45a5323c641064c8467e3ffbe.svg";
export { ForwardRef as ReactComponent };